import { getCurrency } from 'app/BargainWidget/Bargains/utils/currency-utils';

export const isBargainStarted = (bargainRule: any) => {
  const startDate = new Date(bargainRule?.startTime).getTime();
  const now = new Date().getTime();
  return startDate <= now;
};

export const isBargainExpired = (bargainRule: any) => {
  const endDate = new Date(bargainRule?.endTime).getTime();
  const now = new Date().getTime();
  return endDate <= now;
};

export const isBargainStopped = (bargainRule: any) => {
  return bargainRule?.status === 'END' || bargainRule?.status === 'PAUSED';
};

export const detectTranslations = (translations, widgetSettings) => {
  const defaultTranslation = translations && translations?.find(x => x?.defaultLanguage === true);
  let activeLanguage = window?.navigator?.language || window?.['Shopify']?.locale;

  /*if (widgetSettings?.languagePreferred === "USER_BROWSER_BASED") {
    activeLanguage = window?.navigator?.language;
  } else if (widgetSettings?.languagePreferred === "SHOP_ACTIVE_LANGUAGE") {*/
  activeLanguage = window?.['Shopify']?.locale;
  // }
  return (translations && translations?.find(x => activeLanguage?.includes(x?.locale))) || defaultTranslation;
};

export const getValidBargainRuleLatestOne = bargainRules => {
  bargainRules.sort((a, b) => (a?.id > b?.id ? 1 : b?.id > a?.id ? -1 : 0));
  return bargainRules[bargainRules.length - 1];
};

export const detectBargain = (bargainRules, productId, variantId, collections = []) => {
  const rules = bargainRules || [];
  const latestExpiredList = [];
  const latestRunningList = [];

  const {expired: applyAcrossStoreExpired, running: applyAcrossStoreRunning} = rules?.reduce(
    (acc, bargainRule) => {
      if (bargainRule.sourceType === 'ACROSS_STORE' && bargainRule?.status !== 'END') {
        const isExpired = isBargainExpired(bargainRule);
        const isStarted = isBargainStarted(bargainRule);

        if (isExpired && !isStarted) {
          acc.expired.push(bargainRule);
        } else {
          acc.running.push(bargainRule);
        }
      }
      return acc;
    },
    {expired: [], running: []},
  );

  if (applyAcrossStoreExpired.length > 0) {
    if (applyAcrossStoreExpired.length > 1) {
      const expireBargainRules = getValidBargainRuleLatestOne(applyAcrossStoreExpired);
      latestExpiredList.push(expireBargainRules);
    } else {
      const expireBargainRule = applyAcrossStoreExpired[0];
      latestExpiredList.push(expireBargainRule);
    }
  }
  if (applyAcrossStoreRunning.length > 0) {
    if (applyAcrossStoreRunning.length > 1) {
      const latestRunningBargainRule = getValidBargainRuleLatestOne(applyAcrossStoreRunning);
      latestRunningList.push(latestRunningBargainRule);
    } else {
      const latestRunningBargainRule = applyAcrossStoreRunning[0];
      latestRunningList.push(latestRunningBargainRule);
    }
  }

  const productBasedBargainRules = rules?.filter(
    bargainRule => bargainRule?.sourceType === 'PRODUCT' || bargainRule?.sourceType === 'COLLECTION',
  );
  const productsRunning = [];
  const productsExpired = [];
  productBasedBargainRules.forEach(bargainRule => {
    const isExpired = isBargainExpired(bargainRule);
    const isStarted = isBargainStarted(bargainRule);
    const isStopped = isBargainStopped(bargainRule);
    const sourceType = bargainRule?.sourceType;
    const sources = bargainRule?.sources ? JSON.parse(bargainRule?.sources || '[]') : [];

    if (sourceType === 'COLLECTION') {
      const collection = sources?.find(collection => collections?.some(col => parseInt(col?.id) === parseInt(collection?.id)));
      if (collection) {
        if (!isExpired && !isStopped && isStarted) {
          productsRunning.push(bargainRule);
        } else if (isExpired || !isStarted || isStopped) {
          productsExpired.push(bargainRule);
        }
      }
    } else if (sourceType === 'PRODUCT') {
      const product = sources.find(
        product => parseInt(product?.productId) === parseInt(productId) && parseInt(product?.variantId) === parseInt(variantId),
      );
      if (product && !isExpired && !isStopped && isStarted) {
        productsRunning.push(bargainRule);
      } else if (product && (isExpired || !isStarted || isStopped)) {
        productsExpired.push(bargainRule);
      }
    }
  });

  if (productsExpired.length > 0) {
    const expireBargainRule = getValidBargainRuleLatestOne(productsExpired);
    latestExpiredList.push(expireBargainRule);
  }
  if (productsRunning.length > 0) {
    const latestRunningBargainRule = getValidBargainRuleLatestOne(productsRunning);
    latestRunningList.push(latestRunningBargainRule);
  }

  if (latestRunningList.length > 0) {
    const findLatestRunningBargainRules = latestRunningList?.filter(
      bargainRule => bargainRule?.status !== 'END' && !isBargainExpired(bargainRule),
    );
    const bargainRule = getValidBargainRuleLatestOne(findLatestRunningBargainRules);
    if (bargainRule) {
      return bargainRule;
    } else {
      if (latestExpiredList.length === 0) {
        const findLatestRunningExpiredBargainRules = latestRunningList?.filter(
          auction => auction?.status !== 'END' && isBargainExpired(auction),
        );
        const runningExpiredBargainRule = getValidBargainRuleLatestOne(findLatestRunningExpiredBargainRules);
        if (runningExpiredBargainRule) {
          latestExpiredList.push(runningExpiredBargainRule);
        }
      }

      const bargainRule = getValidBargainRuleLatestOne(latestExpiredList);
      if (bargainRule) {
        return bargainRule;
      } else {
        return null;
      }
    }
  } else {
    const bargainRule = getValidBargainRuleLatestOne(latestExpiredList);
    const hideWidgetOnNoBargainRule = true && (isBargainStopped(bargainRule) || isBargainExpired(bargainRule));
    if (bargainRule && !hideWidgetOnNoBargainRule) {
      return bargainRule;
    } else {
      return null;
    }
  }
};

const formatNumber = num => {
  if (typeof num === 'number') {
    if (Number.isInteger(num) || num % 1 === 0) {
      return num.toFixed(0);
    } else {
      return num.toFixed(2);
    }
  }
  return 0;
};

export const getMinimumPrice = (bargainRule, productPrice) => {
  let priceType;
  let amount;

  if (bargainRule?.applyMinimumPrice === true && bargainRule?.minimumPrice !== null) {
    priceType = bargainRule?.minimumPriceType;
    amount = bargainRule?.minimumPrice;
  }

  let activeCurrency = getCurrency();
  if (priceType === 'PERCENTAGE') {
    let convertedAmount = 0;
    if (bargainRule?.currency && bargainRule?.currency !== activeCurrency && !ignoreShopsForConvert.includes(window?.['Shopify']?.shop)) {
      convertedAmount = window?.['Currency']?.convert(amount, bargainRule?.currency, activeCurrency);
    } else {
      convertedAmount = amount;
    }
    const finalAmount = (convertedAmount / 100) * productPrice;
    return formatNumber(finalAmount);
  } else {
    if (bargainRule?.currency && bargainRule?.currency !== activeCurrency && !ignoreShopsForConvert.includes(window?.['Shopify']?.shop)) {
      const finalAmount = window?.['Currency']?.convert(amount, bargainRule?.currency, activeCurrency);
      return cappedAmount(finalAmount);
    } else {
      return amount;
    }
  }
};

const ignoreShopsForConvert = ['creedvintage.myshopify.com'];

export const convertPrice = (bargainRule, productPrice) => {
  let activeCurrency = getCurrency();
  if (bargainRule?.currency && bargainRule?.currency !== activeCurrency && !ignoreShopsForConvert.includes(window?.['Shopify']?.shop)) {
    const finalAmount = window?.['Currency']?.convert(productPrice, bargainRule?.currency, activeCurrency);
    return cappedAmount(finalAmount);
  } else {
    return productPrice;
  }
};

const cappedAmount = (value) => {
  let formattedValue = value?.toFixed(2); // Limit to two decimal places
  if (Number.isInteger(value)) {
    formattedValue = value?.toFixed(0); // Remove decimal places if the value is an integer
  }
  return parseFloat(formattedValue);
};
